{
  "about.blocks": "被限制的服务器",
  "about.contact": "联系方式：",
  "about.default_locale": "默认",
  "about.disclaimer": "Mastodon 是自由的开源软件，商标由 Mastodon GmbH 持有。",
  "about.domain_blocks.no_reason_available": "原因不可用",
  "about.domain_blocks.preamble": "通常来说，在 Mastodon 上，你可以浏览联邦宇宙中任何一台服务器上的内容，并且和上面的用户互动。但其中一些在本服务器上被设置为例外。",
  "about.domain_blocks.silenced.explanation": "除非明确地搜索并关注对方，否则你不会看到来自此服务器的用户信息与内容。",
  "about.domain_blocks.silenced.title": "已隐藏",
  "about.domain_blocks.suspended.explanation": "此服务器的数据将不会被处理、存储或者交换，本站也将无法和来自此服务器的用户互动或者交流。",
  "about.domain_blocks.suspended.title": "已封禁",
  "about.language_label": "语言",
  "about.not_available": "此信息在当前服务器尚不可用。",
  "about.powered_by": "由 {mastodon} 驱动的去中心化社交媒体",
  "about.rules": "站点规则",
  "account.account_note_header": "个人备注",
  "account.activity": "活动",
  "account.add_note": "添加个人备注",
  "account.add_or_remove_from_list": "从列表中添加或移除",
  "account.badges.admin": "管理员",
  "account.badges.blocked": "已屏蔽",
  "account.badges.bot": "机器人",
  "account.badges.domain_blocked": "已屏蔽域名",
  "account.badges.group": "群组",
  "account.badges.muted": "已停止提醒",
  "account.badges.muted_until": "隐藏直到 {until}",
  "account.block": "屏蔽 @{name}",
  "account.block_domain": "屏蔽 {domain} 实例",
  "account.block_short": "屏蔽",
  "account.blocked": "已屏蔽",
  "account.cancel_follow_request": "撤回关注请求",
  "account.copy": "复制个人资料链接",
  "account.direct": "私下提及 @{name}",
  "account.disable_notifications": "当 @{name} 发布嘟文时不要通知我",
  "account.edit_note": "编辑个人备注",
  "account.edit_profile": "修改个人资料",
  "account.edit_profile_short": "编辑",
  "account.enable_notifications": "当 @{name} 发布嘟文时通知我",
  "account.endorse": "在个人资料中推荐此用户",
  "account.familiar_followers_many": "被 {name1}、{name2}、及 {othersCount, plural, other {其他你认识的 # 人}} 关注",
  "account.familiar_followers_one": "{name1} 关注了此账号",
  "account.familiar_followers_two": "{name1} 和 {name2} 关注了此账号",
  "account.featured": "精选",
  "account.featured.accounts": "个人资料",
  "account.featured.collections": "收藏列表",
  "account.featured.new_collection": "新建收藏列表",
  "account.field_overflow": "显示完整内容",
  "account.filters.all": "所有活动",
  "account.filters.boosts_toggle": "显示转嘟",
  "account.filters.posts_boosts": "嘟文与转嘟",
  "account.filters.posts_only": "嘟文",
  "account.filters.posts_replies": "嘟文与回复",
  "account.filters.replies_toggle": "显示回复",
  "account.follow": "关注",
  "account.follow_back": "回关",
  "account.follow_back_short": "回关",
  "account.follow_request": "请求关注",
  "account.follow_request_cancel": "取消请求",
  "account.follow_request_cancel_short": "取消",
  "account.follow_request_short": "关注请求",
  "account.followers": "关注者",
  "account.followers.empty": "目前无人关注此用户。",
  "account.followers_counter": "{count, plural, other {{counter} 关注者}}",
  "account.followers_you_know_counter": "你认识{counter}个",
  "account.following": "正在关注",
  "account.following_counter": "{count, plural, other {{counter} 正在关注}}",
  "account.follows.empty": "此用户目前未关注任何人。",
  "account.follows_you": "关注了你",
  "account.go_to_profile": "前往个人资料页",
  "account.hide_reblogs": "隐藏来自 @{name} 的转嘟",
  "account.in_memoriam": "谨此纪念。",
  "account.join_modal.day": "天",
  "account.join_modal.me": "你加入 {server} 的时间为",
  "account.join_modal.me_anniversary": "联邦宇宙周年快乐！你加入 {server} 的时间为",
  "account.join_modal.me_today": "这是你加入 {server} 的第一天！",
  "account.join_modal.other": "{name} 加入 {server} 的时间为",
  "account.join_modal.other_today": "这是 {name} 加入 {server} 的第一天！",
  "account.join_modal.share.celebrate": "分享纪念嘟文",
  "account.join_modal.share.intro": "分享介绍嘟文",
  "account.join_modal.share.welcome": "分享欢迎嘟文",
  "account.join_modal.years": "{number, plural, other {年}}",
  "account.joined_short": "加入于",
  "account.languages": "更改订阅语言",
  "account.last_active": "上次活跃",
  "account.link_verified_on": "此链接的所有权已在 {date} 检查",
  "account.locked_info": "此账号已锁嘟。账号所有人会手动审核新关注者。",
  "account.media": "媒体",
  "account.mention": "提及 @{name}",
  "account.menu.add_to_collection": "加入收藏列表…",
  "account.menu.add_to_list": "添加到列表…",
  "account.menu.block": "屏蔽账号",
  "account.menu.block_domain": "屏蔽 {domain}",
  "account.menu.copied": "已复制账号链接到剪贴板",
  "account.menu.copy": "复制链接",
  "account.menu.direct": "私下提及",
  "account.menu.hide_reblogs": "在时间线中隐藏转嘟",
  "account.menu.mention": "提及",
  "account.menu.mute": "停止提醒账号",
  "account.menu.note.description": "仅自己可见",
  "account.menu.open_original_page": "在 {domain} 上查看",
  "account.menu.remove_follower": "移除关注者",
  "account.menu.report": "举报账号",
  "account.menu.share": "分享…",
  "account.menu.show_reblogs": "在时间线中显示转嘟",
  "account.menu.unblock": "取消屏蔽账号",
  "account.menu.unblock_domain": "取消屏蔽 {domain}",
  "account.menu.unmute": "恢复提醒账号",
  "account.moved_to": "{name} 的新账号是：",
  "account.mute": "隐藏 @{name}",
  "account.mute_notifications_short": "关闭通知",
  "account.mute_short": "隐藏",
  "account.muted": "已隐藏",
  "account.mutual": "你们互相关注",
  "account.name.copy": "复制用户名",
  "account.name.help.domain": "{domain} 是托管该用户个人资料及嘟文的服务器。",
  "account.name.help.domain_self": "{domain} 是托管你的个人资料及嘟文的服务器。",
  "account.name.help.footer": "就像你可以用不同的电子邮箱向其他人发送同样的电子邮件一般，你也可以和其他 Mastodon 服务器上的用户互动，甚至还能和与其他联邦宇宙软件上的任何人互动。",
  "account.name.help.header": "用户名类似电子邮件地址",
  "account.name.help.username": "{username} 是此账号在其服务器上的用户名。另一个服务器上的其他人可能拥有相同的用户名。",
  "account.name.help.username_self": "{username} 是你在此服务器上的用户名。另一个服务器上的其他人可能拥有相同的用户名。",
  "account.name_info": "这是什么？",
  "account.no_bio": "未提供描述。",
  "account.node_modal.callout": "个人备注仅自己可见。",
  "account.node_modal.edit_title": "编辑个人备注",
  "account.node_modal.error_unknown": "无法保存备注",
  "account.node_modal.field_label": "个人备注",
  "account.node_modal.save": "保存",
  "account.node_modal.title": "添加个人备注",
  "account.note.edit_button": "编辑",
  "account.note.title": "个人备注（仅自己可见）",
  "account.open_original_page": "打开原始页面",
  "account.pending": "待定",
  "account.posts": "嘟文",
  "account.remove_from_followers": "从关注者中移除 {name}",
  "account.report": "举报 @{name}",
  "account.requested_follow": "{name} 向你发送了关注请求",
  "account.share": "分享 @{name} 的个人资料",
  "account.show_reblogs": "显示来自 @{name} 的转嘟",
  "account.statuses_counter": "{count, plural, other {{counter} 条嘟文}}",
  "account.timeline.pinned": "已置顶",
  "account.timeline.pinned.view_all": "查看全部置顶嘟文",
  "account.unblock": "取消屏蔽 @{name}",
  "account.unblock_domain": "取消屏蔽 {domain} 域名",
  "account.unblock_domain_short": "取消屏蔽",
  "account.unblock_short": "取消屏蔽",
  "account.unendorse": "不在个人资料中推荐此用户",
  "account.unfollow": "取消关注",
  "account.unmute": "不再隐藏 @{name}",
  "account.unmute_notifications_short": "恢复通知",
  "account.unmute_short": "取消隐藏",
  "account_edit.advanced_settings.bot_hint": "来自这个账号的绝大多数操作都是自动进行的，并且可能无人监控",
  "account_edit.advanced_settings.bot_label": "机器人账号",
  "account_edit.advanced_settings.title": "高级设置",
  "account_edit.bio.add_label": "添加个人简介",
  "account_edit.bio.edit_label": "编辑个人简介",
  "account_edit.bio.placeholder": "添加一段简短介绍，帮助其他人认识你。",
  "account_edit.bio.title": "个人简介",
  "account_edit.bio_modal.add_title": "添加个人简介",
  "account_edit.bio_modal.edit_title": "编辑个人简介",
  "account_edit.column_button": "完成",
  "account_edit.column_title": "修改个人资料",
  "account_edit.custom_fields.add_label": "添加字段",
  "account_edit.custom_fields.edit_label": "编辑字段",
  "account_edit.custom_fields.placeholder": "添加你的人称代词、外部链接，或其他你想分享的内容。",
  "account_edit.custom_fields.reorder_button": "重新排序字段",
  "account_edit.custom_fields.tip_content": "通过验证任意你拥有网站的链接，你可以轻松增加 Mastodon 账号的可信度。",
  "account_edit.custom_fields.tip_title": "小贴士：添加已验证的链接",
  "account_edit.custom_fields.title": "自定义字段",
  "account_edit.custom_fields.verified_hint": "我如何添加已验证的链接？",
  "account_edit.display_name.add_label": "添加显示名称",
  "account_edit.display_name.edit_label": "编辑显示名称",
  "account_edit.display_name.placeholder": "你的显示名称是指你的名字在个人资料及时间线上出现时的样子。",
  "account_edit.display_name.title": "显示名称",
  "account_edit.featured_hashtags.edit_label": "添加话题标签",
  "account_edit.featured_hashtags.placeholder": "帮助其他人认识并快速访问你最喜欢的话题。",
  "account_edit.featured_hashtags.title": "精选话题标签",
  "account_edit.field_actions.delete": "删除字段",
  "account_edit.field_actions.edit": "编辑字段",
  "account_edit.field_delete_modal.confirm": "你确定要删除此自定义字段吗？此操作无法撤消。",
  "account_edit.field_delete_modal.delete_button": "删除",
  "account_edit.field_delete_modal.title": "删除自定义字段？",
  "account_edit.field_edit_modal.add_title": "添加自定义字段",
  "account_edit.field_edit_modal.discard_confirm": "丢弃",
  "account_edit.field_edit_modal.discard_message": "你有尚未保存的更改。确定要丢弃这些更改吗？",
  "account_edit.field_edit_modal.edit_title": "编辑自定义字段",
  "account_edit.field_edit_modal.length_warning": "已超过建议字数限制。移动端用户可能无法完整看见字段内容。",
  "account_edit.field_edit_modal.link_emoji_warning": "我们建议不要同时使用自定义表情和网址。同时包含两者的自定义字段将会显示为纯文本而不是链接形式，以避免用户混淆。",
  "account_edit.field_edit_modal.name_hint": "例如：“个人网站”",
  "account_edit.field_edit_modal.name_label": "标签",
  "account_edit.field_edit_modal.url_warning": "要添加链接，请在开头加上 {protocol}。",
  "account_edit.field_edit_modal.value_hint": "例如：“https://example.me”",
  "account_edit.field_edit_modal.value_label": "值",
  "account_edit.field_reorder_modal.drag_cancel": "拖拽已终止。字段“{item}”已被丢弃。",
  "account_edit.field_reorder_modal.drag_end": "字段“{item}”已被丢弃。",
  "account_edit.field_reorder_modal.drag_instructions": "要重新排列自定义字段，请按空格键或回车键。在拖拽时，使用方向键将字段向上或向下移动。再次按空格键或回车键可将字段放置在新位置，或按 Esc 键取消。",
  "account_edit.field_reorder_modal.drag_move": "字段“{item}”已被移动。",
  "account_edit.field_reorder_modal.drag_over": "字段“{item}”已被移动到“{over}”上方。",
  "account_edit.field_reorder_modal.drag_start": "已选中字段“{item}”。",
  "account_edit.field_reorder_modal.handle_label": "拖拽字段“{item}”",
  "account_edit.field_reorder_modal.title": "重新排列字段",
  "account_edit.image_alt_modal.add_title": "添加替代文本",
  "account_edit.image_alt_modal.details_content": "建议这么做：<ul> <li>根据图片内容描述你自己的样子</li> <li>文本使用第三人称（例如称呼自己为“Alex”而不是“我”）</li> <li>保持简洁：通常只需要简单描述一下</li> </ul> 不建议这么做：<ul> <li>以“……的图片”开头或结尾：屏幕阅读器自己会说这是图片</li> </ul> 示例：<ul> <li>“穿绿色衬衫戴着眼镜的Alex”</li> </ul>",
  "account_edit.image_alt_modal.details_title": "小贴士：为头像添加替代文本的注意事项",
  "account_edit.image_alt_modal.edit_title": "编辑替代文本",
  "account_edit.image_alt_modal.text_hint": "替代文本可以帮助使用屏幕阅读器的用户理解你的内容。",
  "account_edit.image_alt_modal.text_label": "替代文本",
  "account_edit.image_delete_modal.confirm": "确定要删除此图片吗？此操作无法撤销。",
  "account_edit.image_delete_modal.delete_button": "删除",
  "account_edit.image_delete_modal.title": "删除图片吗？",
  "account_edit.image_edit.add_button": "添加图片",
  "account_edit.image_edit.alt_add_button": "添加替代文本",
  "account_edit.image_edit.alt_edit_button": "编辑替代文本",
  "account_edit.image_edit.remove_button": "移除图片",
  "account_edit.image_edit.replace_button": "替换图片",
  "account_edit.item_list.delete": "删除 {name}",
  "account_edit.item_list.edit": "编辑 {name}",
  "account_edit.name_modal.add_title": "添加显示名称",
  "account_edit.name_modal.edit_title": "编辑显示名称",
  "account_edit.profile_tab.button_label": "自定义",
  "account_edit.profile_tab.hint.description": "这些设置可以自定义用户使用官方应用程序时在 {server} 上可以看到的内容，但可能不适用于外站及第三方应用程序上的用户。",
  "account_edit.profile_tab.hint.title": "实际的显示情况可能不同",
  "account_edit.profile_tab.show_featured.description": "你可以使用可选的“精选”选项卡来展示其他账号。",
  "account_edit.profile_tab.show_featured.title": "显示“精选”选项卡",
  "account_edit.profile_tab.show_media.description": "可选的“媒体”选项卡可以显示你发布的包含图片或视频的嘟文。",
  "account_edit.profile_tab.show_media.title": "显示“媒体”选项卡",
  "account_edit.profile_tab.show_media_replies.description": "如果启用，媒体选项卡将同时显示你的嘟文及你对其他人嘟文的回复。",
  "account_edit.profile_tab.show_media_replies.title": "在“媒体”选项卡中包括回复",
  "account_edit.profile_tab.show_relations.description": "在个人资料中向其他人显示你关注的账号及关注你的账号。无论设置为是否，其他用户总是可以看到你是否关注了他。",
  "account_edit.profile_tab.show_relations.title": "公开“关注者”与“我关注的”",
  "account_edit.profile_tab.subtitle": "自定义你个人资料的显示方式。",
  "account_edit.profile_tab.title": "个人资料显示设置",
  "account_edit.save": "保存",
  "account_edit.upload_modal.back": "上一步",
  "account_edit.upload_modal.done": "完成",
  "account_edit.upload_modal.next": "下一步",
  "account_edit.upload_modal.step_crop.zoom": "缩放",
  "account_edit.upload_modal.step_upload.button": "浏览文件",
  "account_edit.upload_modal.step_upload.dragging": "将文件拖放到此处开始上传",
  "account_edit.upload_modal.step_upload.header": "选择图片",
  "account_edit.upload_modal.step_upload.hint": "支持 WEBP、PNG、GIF 或 JPG 格式，最大 {limit} MB。{br}图片将被缩放至 {width}×{height}px。",
  "account_edit.upload_modal.title_add.avatar": "添加头像",
  "account_edit.upload_modal.title_add.header": "添加封面图",
  "account_edit.upload_modal.title_replace.avatar": "替换头像",
  "account_edit.upload_modal.title_replace.header": "替换封面图",
  "account_edit.verified_modal.details": "要增加 Mastodon 个人资料的可信度，可以验证指向个人网站的链接。运作方式如下：",
  "account_edit.verified_modal.invisible_link.details": "将链接添加到标头（header）中。其中很重要的部分是 rel=\"me\"，可以防止他人通过用户生成内容模仿。你甚至可以在页面标头中使用 link 标签而不是 {tag}，但包含该部分的 HTML 必须在没有 JavaScript 执行环境下访问时依然存在。",
  "account_edit.verified_modal.invisible_link.summary": "如何隐藏此链接？",
  "account_edit.verified_modal.step1.header": "复制下面的 HTML 代码并粘贴到你网站的标头中",
  "account_edit.verified_modal.step2.details": "如果已经将你的网站添加到自定义字段中，你需要删除并重新添加以触发验证。",
  "account_edit.verified_modal.step2.header": "将你的网站添加到自定义字段",
  "account_edit.verified_modal.title": "如何添加已验证的链接",
  "account_edit_tags.add_tag": "添加 #{tagName}",
  "account_edit_tags.column_title": "编辑标签​​​​​",
  "account_edit_tags.help_text": "精选话题标签可以帮助他人发现并与你的个人资料互动。这些标签会作为过滤器条件出现在你个人资料页面的活动视图中。",
  "account_edit_tags.max_tags_reached": "你已达到精选话题标签数量的上限。",
  "account_edit_tags.search_placeholder": "输入话题标签…",
  "account_edit_tags.suggestions": "建议：",
  "account_edit_tags.tag_status_count": "{count, plural, other {# 条嘟文}}",
  "account_list.hidden_notice": "此内容仅自己可见。如需向他人展示此列表，请前往<link>{page} > {modal} > {field}</link>。",
  "account_list.total": "{total, plural, other {# 个账号}}",
  "admin.dashboard.daily_retention": "注册后用户留存率（按日计算）",
  "admin.dashboard.monthly_retention": "注册后用户留存率（按月计算）",
  "admin.dashboard.retention.average": "平均",
  "admin.dashboard.retention.cohort": "注册月份",
  "admin.dashboard.retention.cohort_size": "新用户",
  "admin.impact_report.instance_accounts": "将被删除的账号",
  "admin.impact_report.instance_followers": "本站用户即将丢失的关注者",
  "admin.impact_report.instance_follows": "对方站点用户即将丢失的关注者",
  "admin.impact_report.title": "影响摘要",
  "alert.rate_limited.message": "请在 {retry_time, time, medium} 后重试。",
  "alert.rate_limited.title": "频率受限",
  "alert.unexpected.message": "发生了意外错误。",
  "alert.unexpected.title": "哎呀！",
  "alt_text_badge.title": "替代文本",
  "alt_text_modal.add_alt_text": "添加替代文本",
  "alt_text_modal.add_text_from_image": "从图像中添加文本",
  "alt_text_modal.cancel": "取消",
  "alt_text_modal.change_thumbnail": "更改缩略图",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "请为听力障碍人士描述此内容…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "请为视力障碍人士描述此内容…",
  "alt_text_modal.done": "完成",
  "announcement.announcement": "公告",
  "annual_report.announcement.action_build": "构建我的 Wrapstodon 年度回顾",
  "annual_report.announcement.action_dismiss": "不了，谢谢",
  "annual_report.announcement.action_view": "查看我的 Wrapstodon 年度回顾",
  "annual_report.announcement.description": "探索更多关于你过去一年在 Mastodon 上的互动情况。",
  "annual_report.announcement.title": "Wrapstodon {year} 年度回顾来啦",
  "annual_report.nav_item.badge": "新",
  "annual_report.shared_page.donate": "捐助",
  "annual_report.shared_page.footer": "由 Mastodon 团队用 {heart} 生成",
  "annual_report.shared_page.footer_server_info": "{username} 使用 {domain}，运行 Mastodon 的众多社区之一。",
  "annual_report.summary.archetype.booster.desc_public": "{name}持续寻找值得转嘟的嘟文，以精准眼光放大其他创作者的影响力。",
  "annual_report.summary.archetype.booster.desc_self": "你持续寻找值得转嘟的嘟文，以精准眼光放大其他创作者的影响力。",
  "annual_report.summary.archetype.booster.name": "转发游侠",
  "annual_report.summary.archetype.die_drei_fragezeichen": "？？？",
  "annual_report.summary.archetype.lurker.desc_public": "我们知道{name}曾在联邦宇宙的某个角落驻足，以自己的方式静静享受着Mastodon。",
  "annual_report.summary.archetype.lurker.desc_self": "我们知道你曾在联邦宇宙的某个角落驻足，以自己的方式静静享受着Mastodon。",
  "annual_report.summary.archetype.lurker.name": "吃瓜群众",
  "annual_report.summary.archetype.oracle.desc_public": "{name}发布的新嘟文远多于回复，为Mastodon注入无限活力与未来。",
  "annual_report.summary.archetype.oracle.desc_self": "你发布的新嘟文远多于回复，为Mastodon注入无限活力与未来。",
  "annual_report.summary.archetype.oracle.name": "创作先知",
  "annual_report.summary.archetype.pollster.desc_public": "{name}发起投票的次数远多于其他嘟文类型，不断激发Mastodon上大家的好奇心。",
  "annual_report.summary.archetype.pollster.desc_self": "你发起投票的次数远多于其他嘟文类型，不断激发Mastodon上大家的好奇心。",
  "annual_report.summary.archetype.pollster.name": "探求先锋",
  "annual_report.summary.archetype.replier.desc_public": "{name}经常回复其他人的嘟文，为Mastodon培育新讨论的萌芽。",
  "annual_report.summary.archetype.replier.desc_self": "你经常回复其他人的嘟文，为Mastodon培育新讨论的萌芽。",
  "annual_report.summary.archetype.replier.name": "社交蝴蝶",
  "annual_report.summary.archetype.reveal": "揭示我的画像",
  "annual_report.summary.archetype.reveal_description": "感谢你成为Mastodon的一份子！是时候揭晓你{year}年的用户画像啦。",
  "annual_report.summary.archetype.title_public": "{name}的画像",
  "annual_report.summary.archetype.title_self": "你的画像",
  "annual_report.summary.close": "关闭",
  "annual_report.summary.copy_link": "复制链接",
  "annual_report.summary.followers.new_followers": "{count, plural, other {位新关注者}}",
  "annual_report.summary.highlighted_post.boost_count": "此嘟文被转嘟了 {count, plural, other {# 次}}。",
  "annual_report.summary.highlighted_post.favourite_count": "此嘟文收到了 {count, plural, other {# 次}}喜欢。",
  "annual_report.summary.highlighted_post.reply_count": "此嘟文收到了 {count, plural, other {# 条回复}}。",
  "annual_report.summary.highlighted_post.title": "最热门的嘟文",
  "annual_report.summary.most_used_app.most_used_app": "最常用的应用",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "最常用的话题",
  "annual_report.summary.most_used_hashtag.used_count": "你在 {count, plural, other {# 条嘟文}}中使用了此话题标签。",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} 在 {count, plural, other {# 条嘟文}}中使用了此话题标签。",
  "annual_report.summary.new_posts.new_posts": "新嘟文",
  "annual_report.summary.percentile.text": "<topLabel>这使你跻身 {domain} 用户的前</topLabel><percentage></percentage><bottomLabel></bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": " ",
  "annual_report.summary.share_elsewhere": "分享到其他地方",
  "annual_report.summary.share_message": "我今年的画像是{archetype}！",
  "annual_report.summary.share_on_mastodon": "在Mastodon上分享",
  "attachments_list.unprocessed": "(未处理)",
  "audio.hide": "隐藏音频",
  "block_modal.no_collections": "你们双方都无法将对方加入收藏列表。若适用，你们将会自动从彼此现有的收藏列表中移除。",
  "block_modal.remote_users_caveat": "我们将要求站点 {domain} 尊重你的决定。然而，我们无法保证对方一定遵从，因为某些站点可能会以不同的方案处理屏蔽操作。公开嘟文仍然可能对未登录用户可见。",
  "block_modal.show_less": "折叠",
  "block_modal.show_more": "显示更多",
  "block_modal.they_cant_mention": "你将无法提及、关注、引用彼此。",
  "block_modal.they_cant_see_posts": "他们看不到你发布的内容，你也看不到他们的。",
  "block_modal.they_will_know": "对方将能看到自己被屏蔽。",
  "block_modal.title": "确定要屏蔽此用户？",
  "block_modal.you_wont_see_mentions": "你将不会看到其他人提及对方的嘟文。",
  "boost_modal.combo": "下次按住 {combo} 即可跳过此提示",
  "boost_modal.reblog": "是否要转嘟？",
  "boost_modal.undo_reblog": "是否要取消转嘟？",
  "bundle_column_error.copy_stacktrace": "复制错误报告",
  "bundle_column_error.error.body": "请求的页面无法渲染，可能是代码出现错误或浏览器存在兼容性问题。",
  "bundle_column_error.error.title": "糟糕！",
  "bundle_column_error.network.body": "页面加载出错。目前你的网络连接或这个服务器可能存在问题。",
  "bundle_column_error.network.title": "网络错误",
  "bundle_column_error.retry": "重试",
  "bundle_column_error.return": "返回主页",
  "bundle_column_error.routing.body": "找不到请求的页面。你确定地址栏中的网址输入正确吗？",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "关闭",
  "bundle_modal_error.message": "加载此页面时发生了错误。",
  "bundle_modal_error.retry": "重试",
  "callout.dismiss": "忽略",
  "carousel.current": "<sr>幻灯片</sr> {current, number} / {max, number}",
  "carousel.slide": "第 {current, number} 张幻灯片，共 {max, number} 张",
  "character_counter.recommended": "{currentLength}/{maxLength} 个建议字数",
  "character_counter.required": "{currentLength}/{maxLength} 个字",
  "closed_registrations.other_server_instructions": "基于 Mastodon 去中心化的特性，你可以其他服务器上创建账号，并继续与此服务器互动。",
  "closed_registrations_modal.description": "你目前无法在 {domain} 上创建账号，但请注意，使用 Mastodon 并非需要专门在 {domain} 上注册账号。",
  "closed_registrations_modal.find_another_server": "查找其他服务器",
  "closed_registrations_modal.preamble": "Mastodon 是去中心化的，所以无论在哪个实例创建账号，都可以关注本服务器上的账号并与之交流。 或者你还可以自己搭建实例！",
  "closed_registrations_modal.title": "注册 Mastodon 账号",
  "collection.share_modal.share_link_label": "分享链接",
  "collection.share_modal.share_via_post": "在 Mastodon 上发布",
  "collection.share_modal.share_via_system": "分享到…",
  "collection.share_modal.title": "分享收藏列表",
  "collection.share_modal.title_new": "分享你的新收藏列表！",
  "collection.share_template_other": "发现了个收藏列表，来看看：",
  "collection.share_template_own": "我的新收藏列表，来看看：",
  "collections.account_count": "{count, plural, other {# 个账号}}",
  "collections.accounts.empty_description": "添加最多 {count} 个账号",
  "collections.accounts.empty_editor_title": "此收藏列表中暂无用户",
  "collections.accounts.empty_title": "收藏列表为空",
  "collections.add_to_collection": "将 {name} 添加到收藏列表",
  "collections.block_collection_owner": "屏蔽账号",
  "collections.by_account": "由 {account_handle}",
  "collections.collection_description": "说明",
  "collections.collection_language": "语言",
  "collections.collection_language_none": "无",
  "collections.collection_name": "名称",
  "collections.collection_topic": "话题",
  "collections.confirm_account_removal": "你确定要将从收藏列表中移除此账号吗？",
  "collections.content_warning": "内容警告",
  "collections.continue": "继续",
  "collections.copy_link": "复制链接",
  "collections.copy_link_confirmation": "已复制收藏列表链接到剪贴板",
  "collections.create.accounts_title": "你想在收藏列表中添加哪些人？",
  "collections.create.basic_details_title": "基本信息",
  "collections.create.steps": "第 {step} 步（共 {total} 步）",
  "collections.create_collection": "创建收藏列表",
  "collections.delete_collection": "删除收藏列表",
  "collections.description_length_hint": "100字限制",
  "collections.detail.author_added_you_on_date": "{author} 于 {date} 将你加入",
  "collections.detail.loading": "正在加载收藏列表…",
  "collections.detail.revoke_inclusion": "移除我",
  "collections.detail.sensitive_content": "敏感内容",
  "collections.detail.sensitive_note": "列表说明及其中的账号可能不适合所有人查看。",
  "collections.detail.share": "分享此收藏列表",
  "collections.detail.you_are_in_this_collection": "你被添加到了此收藏列表",
  "collections.edit_details": "编辑详情",
  "collections.error_loading_collections": "加载收藏列表时发生错误。",
  "collections.hidden_accounts_description": "你已屏蔽或隐藏{count, plural, other {部分用户}}",
  "collections.hidden_accounts_link": "{count, plural, other {# 个隐藏账号}}",
  "collections.hints.accounts_counter": "{count}/{max} 个账号",
  "collections.last_updated_at": "最后更新：{date}",
  "collections.list.collections_with_count": "{count, plural, other {# 个收藏列表}}",
  "collections.list.created_by_author": "由 {name} 创建",
  "collections.list.created_by_you": "由你创建",
  "collections.list.featuring_you": "精选了你",
  "collections.manage_accounts": "管理账号",
  "collections.mark_as_sensitive": "标记为敏感内容",
  "collections.mark_as_sensitive_hint": "将此收藏列表的说明用内容警告隐藏。此收藏列表的名称仍将可见。",
  "collections.maximum_collection_count_description": "你的服务器最多只支持创建 {count} 个收藏列表。",
  "collections.maximum_collection_count_reached": "你创建的收藏列表数量已达上限",
  "collections.name_length_hint": "40 字限制",
  "collections.new_collection": "新建收藏列表",
  "collections.pending_accounts.message": "如果系统正在等待来自用户或其服务器的回应，则相应账号会显示为待定状态。只有你可以看见待定账号。",
  "collections.pending_accounts.title": "为什么我会看到待定账号？",
  "collections.remove_account": "移除",
  "collections.report_collection": "举报此收藏列表",
  "collections.revoke_collection_inclusion": "将自己从此收藏列表中移除",
  "collections.revoke_inclusion.confirmation": "你已被从“{collection}”中移除",
  "collections.revoke_inclusion.error": "出现错误，请稍后重试。",
  "collections.search_accounts_label": "搜索要添加的账号",
  "collections.search_accounts_max_reached": "你添加的账号数量已达上限",
  "collections.sensitive": "敏感内容",
  "collections.share_short": "分享",
  "collections.sort_alphabetical": "按字母顺序",
  "collections.sort_by": "排序方式：",
  "collections.sort_date_added": "按添加日期",
  "collections.sort_last_active": "按最后活跃顺序",
  "collections.sort_most_followers": "按关注者最多",
  "collections.suggestions.can_not_add": "无法添加",
  "collections.suggestions.can_not_add_desc": "这些账号可能已主动选择不可被发现，或是他们所在的服务器尚不支持收藏列表。",
  "collections.suggestions.must_follow": "必须先关注",
  "collections.suggestions.must_follow_desc": "这些账号会主动审核所有的关注请求。仅关注者可以将他们加入收藏列表。",
  "collections.topic_hint": "添加话题标签，帮助他人了解此收藏列表的主题。",
  "collections.topic_special_chars_hint": "保存时将自动移除特殊字符",
  "collections.unlisted_collections_description": "这些收藏列表在他人查看时不会出现在你的个人资料上。任何知晓链接的人可以发现这些列表。",
  "collections.unlisted_collections_with_count": "静默公开的收藏列表（{count}）",
  "collections.view_collection": "查看收藏列表",
  "collections.visibility_public": "公开",
  "collections.visibility_public_hint": "可在搜索结果及其他推荐功能可用的区域被发现。",
  "collections.visibility_title": "可见性",
  "collections.visibility_unlisted": "悄悄公开",
  "collections.visibility_unlisted_hint": "对任何知晓链接的人可见。在搜索结果及推荐中隐藏。",
  "column.about": "关于",
  "column.blocks": "屏蔽的用户",
  "column.bookmarks": "书签",
  "column.community": "本站时间线",
  "column.create_list": "创建列表",
  "column.direct": "私下提及",
  "column.directory": "浏览用户资料",
  "column.domain_blocks": "已屏蔽的域名",
  "column.edit_list": "编辑列表",
  "column.favourites": "喜欢",
  "column.firehose": "实时动态",
  "column.firehose_local": "此服务器的实时动态",
  "column.firehose_singular": "实时动态",
  "column.follow_requests": "关注请求",
  "column.home": "主页",
  "column.list_members": "管理列表成员",
  "column.lists": "列表",
  "column.mutes": "已隐藏的用户",
  "column.notifications": "通知",
  "column.other_collections": "{name} 的收藏列表",
  "column.pins": "置顶嘟文",
  "column.public": "跨站公共时间线",
  "column.your_collections": "你的收藏列表",
  "column_back_button.label": "返回",
  "column_header.hide_settings": "隐藏设置",
  "column_header.moveLeft_settings": "将此栏左移",
  "column_header.moveRight_settings": "将此栏右移",
  "column_header.pin": "置顶",
  "column_header.show_settings": "显示设置",
  "column_header.unpin": "取消置顶",
  "column_search.cancel": "取消",
  "combobox.close_results": "关闭结果",
  "combobox.loading": "加载中",
  "combobox.no_results_found": "此搜索没有结果",
  "combobox.open_results": "打开结果",
  "combobox.results_available": "{count, plural, other {# 个建议}}可用。使用上下方向键移动。按 Enter 键选择。",
  "community.column_settings.local_only": "仅限本站",
  "community.column_settings.media_only": "仅媒体",
  "community.column_settings.remote_only": "仅外站",
  "compose.error.blank_post": "嘟文内容不能为空。",
  "compose.language.change": "更改语言",
  "compose.language.search": "搜索语言...",
  "compose.published.body": "嘟文已发布。",
  "compose.published.open": "打开",
  "compose.saved.body": "嘟文已保存。",
  "compose_form.direct_message_warning_learn_more": "详细了解",
  "compose_form.encryption_warning": "Mastodon 上的嘟文未经端到端加密。请勿在 Mastodon 上分享敏感信息。",
  "compose_form.hashtag_warning": "这条嘟文被设置为“不公开”，因此它不会出现在任何话题的列表下。只有公开的嘟文才能通过话题进行搜索。",
  "compose_form.lock_disclaimer": "你的账号没有{locked}。任何人都可以在关注你后立即查看仅关注者可见的嘟文。",
  "compose_form.lock_disclaimer.lock": "锁嘟",
  "compose_form.placeholder": "想写什么？",
  "compose_form.poll.duration": "投票期限",
  "compose_form.poll.multiple": "多选",
  "compose_form.poll.option_placeholder": "选项 {number}",
  "compose_form.poll.single": "单选",
  "compose_form.poll.switch_to_multiple": "将投票改为多选",
  "compose_form.poll.switch_to_single": "将投票改为单选",
  "compose_form.poll.type": "类型",
  "compose_form.publish": "发布",
  "compose_form.reply": "回复",
  "compose_form.save_changes": "更改",
  "compose_form.spoiler.marked": "移除内容警告",
  "compose_form.spoiler.unmarked": "添加内容警告",
  "compose_form.spoiler_placeholder": "内容警告 (可选)",
  "confirmation_modal.cancel": "取消",
  "confirmations.block.confirm": "屏蔽",
  "confirmations.delete.confirm": "删除",
  "confirmations.delete.message": "你确定要删除这条嘟文吗？",
  "confirmations.delete.title": "确定要删除嘟文？",
  "confirmations.delete_collection.confirm": "删除",
  "confirmations.delete_collection.message": "该操作无法撤销。",
  "confirmations.delete_collection.title": "删除“{name}”吗？",
  "confirmations.delete_list.confirm": "删除",
  "confirmations.delete_list.message": "确定要永久删除此列表吗？",
  "confirmations.delete_list.title": "确定要删除列表？",
  "confirmations.discard_draft.confirm": "丢弃并继续",
  "confirmations.discard_draft.edit.cancel": "恢复编辑",
  "confirmations.discard_draft.edit.message": "继续将丢弃你对你正在编辑的嘟文所作的任何更改。",
  "confirmations.discard_draft.edit.title": "是否丢弃你对嘟文的更改？",
  "confirmations.discard_draft.post.cancel": "恢复草稿",
  "confirmations.discard_draft.post.message": "继续将丢弃你正在编辑的嘟文。",
  "confirmations.discard_draft.post.title": "丢弃你的嘟文草稿？",
  "confirmations.discard_edit_media.confirm": "丢弃",
  "confirmations.discard_edit_media.message": "你还有未保存的媒体描述或预览修改，仍要丢弃吗？",
  "confirmations.follow_to_list.confirm": "关注并添加到列表",
  "confirmations.follow_to_list.message": "你需要先关注 {name}，才能将其添加到列表。",
  "confirmations.follow_to_list.title": "确定要关注此用户？",
  "confirmations.hide_featured_tab.confirm": "隐藏选项卡",
  "confirmations.hide_featured_tab.intro": "你可以在<i>修改个人资料 > 个人资料选项卡设置</i>下随时更改此设置。",
  "confirmations.hide_featured_tab.message": "这将会为 {serverName} 及运行最新版本 Mastodon 的其他实例隐藏此选项卡。其他实例的显示情况可能不同。",
  "confirmations.hide_featured_tab.title": "隐藏“精选”选项卡吗？",
  "confirmations.logout.confirm": "退出登录",
  "confirmations.logout.message": "确定要退出登录吗？",
  "confirmations.logout.title": "确定要退出登录？",
  "confirmations.missing_alt_text.confirm": "添加替代文本",
  "confirmations.missing_alt_text.message": "你的帖子包含没有替代文本的媒体。添加描述有助于使更多用户理解你的内容。",
  "confirmations.missing_alt_text.secondary": "就这样发布",
  "confirmations.missing_alt_text.title": "添加替代文本?",
  "confirmations.mute.confirm": "隐藏",
  "confirmations.private_quote_notify.cancel": "返回编辑",
  "confirmations.private_quote_notify.confirm": "发布嘟文",
  "confirmations.private_quote_notify.do_not_show_again": "不再显示此消息",
  "confirmations.private_quote_notify.message": "你所引用与提及的用户将收到通知且能够查看你的嘟文，即便这些用户没有关注你。",
  "confirmations.private_quote_notify.title": "是否和关注者和提及的用户分享此内容？",
  "confirmations.quiet_post_quote_info.dismiss": "不再提醒",
  "confirmations.quiet_post_quote_info.got_it": "明白了",
  "confirmations.quiet_post_quote_info.message": "当你引用悄悄公开的嘟文时，你的嘟文会从热门时间线上隐藏。",
  "confirmations.quiet_post_quote_info.title": "引用悄悄公开的嘟文",
  "confirmations.redraft.confirm": "删除并重新编辑",
  "confirmations.redraft.message": "确定删除这条嘟文并重写吗？所有相关的喜欢和转嘟都将丢失，嘟文的回复也会失去关联。",
  "confirmations.redraft.title": "是否删除并重新编辑嘟文？",
  "confirmations.remove_from_followers.confirm": "移除关注者",
  "confirmations.remove_from_followers.message": "{name} 将停止关注你。你确定要继续吗？",
  "confirmations.remove_from_followers.title": "移除关注者？",
  "confirmations.revoke_collection_inclusion.confirm": "移除我",
  "confirmations.revoke_collection_inclusion.message": "收藏列表的创建者在24小时内将无法再将你重新添加到此收藏列表中。要永久阻止此列表的创建者将你加入其收藏列表，你可以屏蔽此用户。",
  "confirmations.revoke_collection_inclusion.title": "将自己从此收藏列表中移除吗？",
  "confirmations.revoke_quote.confirm": "移除嘟文",
  "confirmations.revoke_quote.message": "此操作无法撤销。",
  "confirmations.revoke_quote.title": "移除嘟文？",
  "confirmations.unblock.confirm": "取消屏蔽",
  "confirmations.unblock.title": "取消屏蔽 {name} 吗？",
  "confirmations.unfollow.confirm": "取消关注",
  "confirmations.unfollow.title": "取关 {name} 吗？",
  "confirmations.withdraw_request.confirm": "撤回请求",
  "confirmations.withdraw_request.title": "撤回关注 {name} 的请求吗？",
  "content_warning.hide": "隐藏嘟文",
  "content_warning.show": "仍要显示",
  "content_warning.show_more": "展开",
  "content_warning.show_short": "显示",
  "conversation.delete": "删除对话",
  "conversation.mark_as_read": "标记为已读",
  "conversation.open": "查看对话",
  "conversation.with": "与 {names}",
  "copy_icon_button.copied": "已复制到剪贴板",
  "copy_icon_button.copy_this_text": "复制链接到剪贴板",
  "copypaste.copied": "已复制",
  "copypaste.copy_to_clipboard": "复制到剪贴板",
  "custom_homepage.about": "关于",
  "custom_homepage.about_this_server": "关于此服务器",
  "custom_homepage.administered_by": "管理者为",
  "custom_homepage.contact": "联系方式：",
  "custom_homepage.latest_activity": "最新动态",
  "custom_homepage.these_are_the_latest_posts": "以下是来自此服务器账号的最新 40 条嘟文。",
  "directory.federated": "来自已知联邦宇宙",
  "directory.local": "仅来自 {domain}",
  "directory.new_arrivals": "新来者",
  "directory.recently_active": "最近活跃",
  "disabled_account_banner.account_settings": "账号设置",
  "disabled_account_banner.text": "你的账号 {disabledAccount} 目前已被禁用。",
  "dismissable_banner.community_timeline": "这些是来自 {domain} 用户的最新公开嘟文。",
  "dismissable_banner.dismiss": "忽略",
  "dismissable_banner.public_timeline": "以下是联邦宇宙中 {domain} 上的用户关注的人发布的最新公开嘟文。",
  "domain_block_modal.block": "屏蔽服务器",
  "domain_block_modal.block_account_instead": "改为屏蔽 @{name}",
  "domain_block_modal.they_can_interact_with_old_posts": "该站点的用户可以与你之前的嘟文交互。",
  "domain_block_modal.they_cant_follow": "该站点上将没有人可以关注你。",
  "domain_block_modal.they_wont_know": "对方不会知道自己被屏蔽。",
  "domain_block_modal.title": "确定要屏蔽此域名？",
  "domain_block_modal.you_will_lose_num_followers": "你将失去 {followersCount, plural, other {{followersCountDisplay} 名关注者}}和 {followingCount, plural, other {{followingCountDisplay} 名关注}}。",
  "domain_block_modal.you_will_lose_relationships": "你将丢失该站点上的全部关注与关注者。",
  "domain_block_modal.you_wont_see_posts": "你将不会看到此服务器上用户的嘟文或通知。",
  "dropdown.empty": "选项",
  "email_subscriptions.email": "电子邮件",
  "email_subscriptions.form.action": "订阅",
  "email_subscriptions.form.bottom": "无需注册 Mastodon 账号，在收件箱中获取嘟文。如果想退订了你可以随时退订。更多信息参见<a>隐私政策</a>。",
  "email_subscriptions.form.title": "订阅 {name} 的电子邮件推送",
  "email_subscriptions.submitted.lead": "请检查你的收件箱来完成邮件订阅注册。",
  "email_subscriptions.submitted.title": "最后一步",
  "email_subscriptions.validation.email.blocked": "电子邮件提供商已封禁",
  "email_subscriptions.validation.email.invalid": "电子邮件地址无效",
  "embed.instructions": "复制下列代码以在你的网站中嵌入此嘟文。",
  "embed.preview": "这是它的预览效果：",
  "emoji_button.activity": "活动",
  "emoji_button.clear": "清除",
  "emoji_button.custom": "自定义",
  "emoji_button.flags": "旗帜",
  "emoji_button.food": "食物与饮料",
  "emoji_button.label": "插入表情符号",
  "emoji_button.nature": "自然",
  "emoji_button.not_found": "未找到匹配的表情符号",
  "emoji_button.objects": "物体",
  "emoji_button.people": "人物",
  "emoji_button.recent": "常用",
  "emoji_button.search": "搜索…",
  "emoji_button.search_results": "搜索结果",
  "emoji_button.symbols": "符号",
  "emoji_button.travel": "旅行与地点",
  "empty_column.account_featured.other": "{acct} 尚未设置任何精选。",
  "empty_column.account_featured_self.no_collections_button": "创建收藏列表",
  "empty_column.account_featured_self.no_collections_hide_tab": "改为隐藏此选项卡",
  "empty_column.account_featured_self.showcase_accounts": "展示你最喜欢的账号",
  "empty_column.account_featured_self.showcase_accounts_desc": "收藏列表包含一些作者精选的账号，可以帮助他人探索更多联邦宇宙的内容。",
  "empty_column.account_featured_unknown.other": "此账号尚未设置任何精选。",
  "empty_column.account_hides_collections": "该用户选择不公开此信息",
  "empty_column.account_suspended": "账号已被停用",
  "empty_column.account_timeline": "这里没有嘟文！",
  "empty_column.account_unavailable": "个人资料不可用",
  "empty_column.blocks": "你还未屏蔽任何用户。",
  "empty_column.bookmarked_statuses": "你还没有给任何嘟文添加书签。添加书签后的嘟文会显示在这里。",
  "empty_column.collections": "{acct} 尚未创建任何收藏列表。",
  "empty_column.collections.featured_in": "你还没有被添加到收藏列表过。",
  "empty_column.collections.featured_in_undiscoverable": "如果想让其他人将你添加到收藏列表，请前往<link>偏好设置 > 隐私与可达性</link>在发现功能中允许推荐",
  "empty_column.collections_self": "你尚未创建任何收藏列表。",
  "empty_column.community": "本站时间线还没有内容，写点什么并公开发布，让它活跃起来吧！",
  "empty_column.direct": "你还未使用过私下提及。当你发出或者收到私下提及时，它将显示在此。",
  "empty_column.disabled_feed": "此动态已被你的服务器管理员禁用。",
  "empty_column.domain_blocks": "暂且没有被屏蔽的站点。",
  "empty_column.explore_statuses": "目前没有热门内容，稍后再来看看吧！",
  "empty_column.favourited_statuses": "你没有喜欢过任何嘟文。喜欢过的嘟文会显示在这里。",
  "empty_column.favourites": "没有人喜欢过这条嘟文。如果有人喜欢了，就会显示在这里。",
  "empty_column.follow_requests": "你还没有收到任何关注请求。当你收到一个关注请求时，它会出现在这里。",
  "empty_column.followed_tags": "你还没有关注任何话题。 当你关注后，它们会出现在这里。",
  "empty_column.hashtag": "该话题下暂无内容。",
  "empty_column.home": "你的主页时间线还没有内容！快去关注更多人吧。",
  "empty_column.list": "列表中还没有任何内容。当列表成员发布新嘟文时，它们将出现在这里。",
  "empty_column.mutes": "你没有隐藏任何用户。",
  "empty_column.notification_requests": "一扫而空！这里没有任何未读通知。当收到新的通知时，将根据你的设置显示在这里。",
  "empty_column.notifications": "你还没有收到过任何通知，快和其他用户互动吧。",
  "empty_column.public": "这里什么都没有！写一些公开的嘟文，或者关注其他服务器的用户后，这里就会有嘟文出现了",
  "empty_state.no_results": "无结果",
  "error.no_hashtag_feed_access": "加入或登录以查看和关注此话题标签。",
  "error.unexpected_crash.explanation": "此页面无法正确显示，这可能是因为我们的代码中有错误，也可能是因为浏览器兼容问题。",
  "error.unexpected_crash.explanation_addons": "此页面无法正确显示，这个错误很可能是由浏览器附加组件或自动翻译工具造成的。",
  "error.unexpected_crash.next_steps": "刷新一下页面试试。如果没用，你可以换个浏览器或者用本地应用。",
  "error.unexpected_crash.next_steps_addons": "请尝试禁用它们并刷新页面。如果没有帮助，你仍可以尝试使用其他浏览器或原生应用来使用 Mastodon。",
  "errors.unexpected_crash.copy_stacktrace": "复制堆栈跟踪信息到剪贴板",
  "errors.unexpected_crash.report_issue": "报告问题",
  "explore.suggested_follows": "用户",
  "explore.title": "当前热门",
  "explore.trending_links": "新闻",
  "explore.trending_statuses": "嘟文",
  "explore.trending_tags": "话题",
  "featured_carousel.current": "<sr>嘟文</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, other {# 条置顶嘟文}}",
  "featured_carousel.slide": "第 {current, number} 条嘟文，共 {max, number} 条",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "你最近发布了有关{items}的内容。要将这些添加为精选的话题标签吗？",
  "featured_tags.suggestions.add": "添加",
  "featured_tags.suggestions.added": "你可以在<link>修改个人资料 > 精选的话题标签</link>下随时管理你精选的话题标签。",
  "featured_tags.suggestions.dismiss": "不了，谢谢",
  "filter_modal.added.context_mismatch_explanation": "这条过滤规则不适用于你当前访问此嘟文的场景。要在此场景下过滤嘟文，你必须编辑此过滤规则。",
  "filter_modal.added.context_mismatch_title": "场景不匹配！",
  "filter_modal.added.expired_explanation": "此过滤规则类别已过期，你需要修改到期日期才能应用。",
  "filter_modal.added.expired_title": "过滤规则已过期！",
  "filter_modal.added.review_and_configure": "要检查并进一步配置这条过滤规则，请前往{settings_link}。",
  "filter_modal.added.review_and_configure_title": "过滤规则设置",
  "filter_modal.added.settings_link": "设置页面",
  "filter_modal.added.short_explanation": "此嘟文已被添加到以下过滤规则：{title}。",
  "filter_modal.added.title": "已添加过滤规则 ！",
  "filter_modal.select_filter.context_mismatch": "不适用于此场景",
  "filter_modal.select_filter.expired": "已过期",
  "filter_modal.select_filter.prompt_new": "新类别：{name}",
  "filter_modal.select_filter.search": "搜索或创建",
  "filter_modal.select_filter.subtitle": "使用已存在类别，或创建新类别",
  "filter_modal.select_filter.title": "过滤此嘟文",
  "filter_modal.title.status": "过滤一条嘟文",
  "filter_warning.matches_filter": "命中过滤规则 “<span>{title}</span>”",
  "filtered_notifications_banner.pending_requests": "来自你可能认识的 {count, plural, =0 {0 个人} other {# 个人}}",
  "filtered_notifications_banner.title": "被过滤的通知",
  "firehose.all": "全部",
  "firehose.local": "此服务器",
  "firehose.remote": "其他服务器",
  "follow_request.authorize": "同意",
  "follow_request.reject": "拒绝",
  "follow_requests.unlocked_explanation": "尽管你没有锁嘟，但是 {domain} 的站务人员认为你也许会想手动审核这些账号的关注请求。",
  "follow_suggestions.curated_suggestion": "站务人员精选",
  "follow_suggestions.dismiss": "不再显示",
  "follow_suggestions.featured_longer": "由 {domain} 管理团队精选",
  "follow_suggestions.friends_of_friends_longer": "在你关注的人中很受欢迎",
  "follow_suggestions.hints.featured": "该账号已被 {domain} 管理团队精选。",
  "follow_suggestions.hints.friends_of_friends": "该账号在你关注的人中很受欢迎。",
  "follow_suggestions.hints.most_followed": "该用户是 {domain} 上关注度最高的用户之一。",
  "follow_suggestions.hints.most_interactions": "该用户最近在 {domain} 获得了很多关注。",
  "follow_suggestions.hints.similar_to_recently_followed": "该用户与你最近关注的人类似。",
  "follow_suggestions.personalized_suggestion": "个性化建议",
  "follow_suggestions.popular_suggestion": "热门建议",
  "follow_suggestions.popular_suggestion_longer": "在 {domain} 上很受欢迎",
  "follow_suggestions.similar_to_recently_followed_longer": "与你近期关注的用户相似",
  "follow_suggestions.view_all": "查看全部",
  "follow_suggestions.who_to_follow": "推荐关注",
  "followed_tags": "已关注话题",
  "followers.hide_other_followers": "该用户选择不展示其他关注者",
  "followers.title": "已关注 {name}",
  "following.hide_other_following": "该用户选择不展示其关注的其他人",
  "following.title": "{name} 关注了此账号",
  "footer.about": "关于",
  "footer.about_mastodon": "关于 Mastodon",
  "footer.about_server": "关于 {domain}",
  "footer.about_this_server": "关于本站",
  "footer.classic": "怀旧服",
  "footer.directory": "用户列表",
  "footer.get_app": "获取应用",
  "footer.keyboard_shortcuts": "快捷键",
  "footer.privacy_policy": "隐私政策",
  "footer.seaofog": "雾海",
  "footer.source_code": "查看源代码",
  "footer.status": "状态",
  "footer.terms_of_service": "服务条款",
  "form_error.blank": "字段不能为空。",
  "form_field.optional": "（选填）",
  "getting_started.heading": "开始使用",
  "hashtag.admin_moderation": "打开 #{name} 的管理界面",
  "hashtag.browse": "浏览#{hashtag}中的贴子",
  "hashtag.browse_from_account": "浏览#{hashtag}中来自@{name}的贴子",
  "hashtag.column_header.tag_mode.all": "以及 {additional}",
  "hashtag.column_header.tag_mode.any": "或是 {additional}",
  "hashtag.column_header.tag_mode.none": "而不用 {additional}",
  "hashtag.column_settings.select.no_options_message": "未找到建议",
  "hashtag.column_settings.select.placeholder": "输入话题…",
  "hashtag.column_settings.tag_mode.all": "全部",
  "hashtag.column_settings.tag_mode.any": "任一",
  "hashtag.column_settings.tag_mode.none": "无一",
  "hashtag.column_settings.tag_toggle": "在此栏加入额外的标签",
  "hashtag.counter_by_accounts": "{count, plural,other {{counter} 人讨论}}",
  "hashtag.counter_by_uses": "{count, plural, other {{counter} 条嘟文}}",
  "hashtag.counter_by_uses_today": "今日 {count, plural, other {{counter} 条嘟文}}",
  "hashtag.feature": "设为精选",
  "hashtag.follow": "关注话题",
  "hashtag.mute": "停止提醒 #{hashtag}",
  "hashtag.unfeature": "取消精选",
  "hashtag.unfollow": "取消关注话题",
  "hashtags.and_other": "… 和另外 {count, plural, other {# 个话题}}",
  "hints.profiles.followers_may_be_missing": "该账号的关注者列表可能没有完全显示。",
  "hints.profiles.follows_may_be_missing": "该账号的关注列表可能没有完全显示。",
  "hints.profiles.posts_may_be_missing": "该账号的嘟文可能没有完全显示。",
  "hints.profiles.see_more_followers": "在 {domain} 查看更多关注者",
  "hints.profiles.see_more_follows": "在 {domain} 查看更多关注",
  "hints.profiles.see_more_posts": "在 {domain} 查看更多嘟文",
  "home.column_settings.show_quotes": "显示引用",
  "home.column_settings.show_reblogs": "显示转嘟",
  "home.column_settings.show_replies": "显示回复",
  "home.hide_announcements": "隐藏公告",
  "home.pending_critical_update.body": "请尽快更新你的 Mastodon 服务器！",
  "home.pending_critical_update.link": "查看更新",
  "home.pending_critical_update.title": "有紧急安全更新！",
  "home.show_announcements": "显示公告",
  "ignore_notifications_modal.bots_title": "是否忽略来自机器人账号的通知？",
  "ignore_notifications_modal.disclaimer": "Mastodon无法通知对方用户你忽略了他们的通知。忽略通知不会阻止消息本身的发送。",
  "ignore_notifications_modal.filter_instead": "改为过滤",
  "ignore_notifications_modal.filter_to_act_users": "你仍然可以接受、拒绝或举报用户",
  "ignore_notifications_modal.filter_to_avoid_confusion": "选择过滤有助于避免潜在的混淆",
  "ignore_notifications_modal.filter_to_review_separately": "你可以单独查看被过滤的通知",
  "ignore_notifications_modal.ignore": "忽略通知",
  "ignore_notifications_modal.limited_accounts_title": "是否忽略来自受限账号的通知？",
  "ignore_notifications_modal.new_accounts_title": "是否忽略来自新账号的通知？",
  "ignore_notifications_modal.not_followers_title": "是否忽略未关注你的人的通知？",
  "ignore_notifications_modal.not_following_title": "是否忽略你未关注的人的通知？",
  "ignore_notifications_modal.private_mentions_title": "是否忽略不请自来的私下提及？",
  "info_button.label": "帮助",
  "info_button.what_is_alt_text": "<h1>什么是替代文本？</h1> <p>替代文本为视力障碍者、低带宽连接用户或需要额外背景信息的用户提供图像描述。</p> <p>通过编写清晰、简洁、客观的替代文本，可以提升所有人的可访问性和理解力。</p> <ul> <li>捕捉重要元素</li> <li>总结图像中的文本</li> <li>使用常规句子结构</li> <li>避免冗余信息</li> <li>关注复杂视觉内容(如图表或地图)中的趋势和关键信息</li> </ul>",
  "interaction_modal.action": "要和 {name} 的嘟文互动，你需要登录到你在Mastodon服务器上注册的账号。",
  "interaction_modal.action_follow": "要关注 {name}，你需要登录到你在Mastodon服务器上注册的账号。",
  "interaction_modal.go": "跳转",
  "interaction_modal.no_account_yet": "还没有账号？",
  "interaction_modal.on_another_server": "在另一服务器",
  "interaction_modal.on_this_server": "在此服务器",
  "interaction_modal.title": "登录以继续",
  "interaction_modal.username_prompt": "例如: {example}",
  "intervals.full.days": "{number} 天",
  "intervals.full.hours": "{number} 小时",
  "intervals.full.minutes": "{number} 分钟",
  "keyboard_shortcuts.back": "返回上一页",
  "keyboard_shortcuts.blocked": "打开被屏蔽用户列表",
  "keyboard_shortcuts.boost": "转嘟",
  "keyboard_shortcuts.column": "选中某栏",
  "keyboard_shortcuts.compose": "选择输入框",
  "keyboard_shortcuts.description": "说明",
  "keyboard_shortcuts.direct": "打开私下提及栏",
  "keyboard_shortcuts.down": "在列表中让光标下移",
  "keyboard_shortcuts.enter": "展开嘟文",
  "keyboard_shortcuts.explore": "打开当前热门时间线",
  "keyboard_shortcuts.favourite": "喜欢嘟文",
  "keyboard_shortcuts.favourites": "打开喜欢列表",
  "keyboard_shortcuts.federated": "打开跨站时间线",
  "keyboard_shortcuts.heading": "快捷键列表",
  "keyboard_shortcuts.home": "打开主页时间线",
  "keyboard_shortcuts.hotkey": "快捷键",
  "keyboard_shortcuts.keys.alt": "Alt",
  "keyboard_shortcuts.keys.backspace": "Backspace",
  "keyboard_shortcuts.keys.enter": "Enter",
  "keyboard_shortcuts.keys.esc": "Esc",
  "keyboard_shortcuts.keys.page_down": "Page Down",
  "keyboard_shortcuts.keys.page_up": "Page Up",
  "keyboard_shortcuts.legend": "显示此列表",
  "keyboard_shortcuts.load_more": "将焦点移至“加载更多”按钮",
  "keyboard_shortcuts.local": "打开本站时间线",
  "keyboard_shortcuts.mention": "提及嘟文作者",
  "keyboard_shortcuts.muted": "打开隐藏用户列表",
  "keyboard_shortcuts.my_profile": "打开你的个人资料",
  "keyboard_shortcuts.notifications": "打开通知栏",
  "keyboard_shortcuts.open_media": "打开媒体",
  "keyboard_shortcuts.pinned": "打开置顶嘟文列表",
  "keyboard_shortcuts.profile": "打开作者的个人资料",
  "keyboard_shortcuts.quote": "引用嘟文",
  "keyboard_shortcuts.reply": "回复嘟文",
  "keyboard_shortcuts.requests": "打开关注请求列表",
  "keyboard_shortcuts.search": "选中搜索框",
  "keyboard_shortcuts.spoilers": "显示或隐藏被折叠的正文",
  "keyboard_shortcuts.start": "打开“开始使用”栏",
  "keyboard_shortcuts.toggle_hidden": "显示或隐藏被折叠的正文",
  "keyboard_shortcuts.toggle_sensitivity": "显示/隐藏媒体",
  "keyboard_shortcuts.toot": "发送新嘟文",
  "keyboard_shortcuts.top": "移动到列表顶部",
  "keyboard_shortcuts.translate": "翻译嘟文",
  "keyboard_shortcuts.unfocus": "取消输入/搜索",
  "keyboard_shortcuts.up": "在列表中让光标上移",
  "learn_more_link.got_it": "明白了",
  "learn_more_link.learn_more": "了解更多",
  "lightbox.close": "关闭",
  "lightbox.next": "下一个",
  "lightbox.previous": "上一个",
  "lightbox.zoom_in": "缩放为实际大小",
  "lightbox.zoom_out": "缩放到适合窗口大小",
  "limited_account_hint.action": "仍要显示个人资料",
  "limited_account_hint.title": "此账号资料或服务器已被 {domain} 管理员隐藏。",
  "link_preview.author": "由 {name}",
  "link_preview.more_from_author": "查看 {name} 的更多内容",
  "link_preview.shares": "{count, plural, other {{counter} 条嘟文}}",
  "lists.add_member": "添加",
  "lists.add_to_list": "添加到列表",
  "lists.add_to_lists": "把 {name} 添加到列表",
  "lists.create": "创建",
  "lists.create_a_list_to_organize": "新建一个列表，整理你的主页动态",
  "lists.create_list": "创建列表",
  "lists.delete": "删除列表",
  "lists.done": "完成",
  "lists.edit": "编辑列表",
  "lists.exclusive": "在主页动态中隐藏列表成员",
  "lists.exclusive_hint": "列表成员的嘟文将不会在你的主页动态中显示，以免重复阅读。",
  "lists.find_users_to_add": "查找要添加的用户",
  "lists.list_members_count": "{count, plural, other {# 人}}",
  "lists.list_name": "列表名称",
  "lists.new_list_name": "新列表名称",
  "lists.no_lists_yet": "尚无列表。",
  "lists.no_members_yet": "尚无成员。",
  "lists.no_results_found": "未找到结果。",
  "lists.remove_member": "移除",
  "lists.replies_policy.followed": "所有我关注的用户",
  "lists.replies_policy.list": "列表成员",
  "lists.replies_policy.none": "不显示",
  "lists.save": "保存",
  "lists.search": "搜索",
  "lists.show_replies_to": "列表成员回复的显示范围",
  "load_pending": "{count} 项",
  "loading_indicator.label": "加载中…",
  "media_gallery.hide": "隐藏",
  "moved_to_account_banner.text": "你的账号 {disabledAccount} 已禁用，因为你已迁移到 {movedToAccount}。",
  "mute_modal.hide_from_notifications": "从通知中隐藏",
  "mute_modal.hide_options": "隐藏选项",
  "mute_modal.indefinite": "直到我取消隐藏他们",
  "mute_modal.show_options": "显示选项",
  "mute_modal.they_can_mention_and_follow": "对方可以提及和关注你，但是你看不到对方。",
  "mute_modal.they_wont_know": "对方不会知道自己被隐藏。",
  "mute_modal.title": "隐藏该用户？",
  "mute_modal.you_wont_see_mentions": "你看不到提及对方的嘟文。",
  "mute_modal.you_wont_see_posts": "对方可以看到你的嘟文，但是你看不到对方的。",
  "navigation_bar.about": "关于",
  "navigation_bar.account_settings": "密码与安全",
  "navigation_bar.administration": "管理",
  "navigation_bar.advanced_interface": "在高级网页界面中打开",
  "navigation_bar.automated_deletion": "自动删除嘟文",
  "navigation_bar.blocks": "已屏蔽的用户",
  "navigation_bar.bookmarks": "书签",
  "navigation_bar.collections": "收藏列表",
  "navigation_bar.direct": "私下提及",
  "navigation_bar.domain_blocks": "已屏蔽的域名",
  "navigation_bar.favourites": "喜欢",
  "navigation_bar.filters": "忽略的关键词",
  "navigation_bar.follow_requests": "关注请求",
  "navigation_bar.followed_tags": "关注的话题",
  "navigation_bar.follows_and_followers": "关注与关注者",
  "navigation_bar.import_export": "导入与导出",
  "navigation_bar.lists": "列表",
  "navigation_bar.live_feed_local": "实时动态（本站）",
  "navigation_bar.live_feed_public": "实时动态（公开）",
  "navigation_bar.logout": "退出登录",
  "navigation_bar.main": "主要",
  "navigation_bar.moderation": "审核",
  "navigation_bar.more": "更多",
  "navigation_bar.mutes": "已隐藏的用户",
  "navigation_bar.opened_in_classic_interface": "嘟文页、个人资料与其他某些页面默认在经典网页界面中打开。",
  "navigation_bar.preferences": "偏好设置",
  "navigation_bar.privacy_and_reach": "隐私与可达性",
  "navigation_bar.search": "搜索",
  "navigation_bar.search_trends": "搜索/热门趋势",
  "navigation_panel.collapse_followed_tags": "收起已关注话题菜单",
  "navigation_panel.collapse_lists": "收起菜单列表",
  "navigation_panel.expand_followed_tags": "展开已关注话题菜单",
  "navigation_panel.expand_lists": "展开菜单列表",
  "not_signed_in_indicator.not_signed_in": "你需要登录才能访问此资源。",
  "notification.added_to_collection": "{name} 将你添加到了收藏列表",
  "notification.admin.report": "{name} 举报了 {target}",
  "notification.admin.report_account": "{name} 举报了来自 {target} 的 {count, plural, other {# 条嘟文}}，原因为 {category}",
  "notification.admin.report_account_other": "{name} 举报了来自 {target} 的 {count, plural, other {# 条嘟文}}",
  "notification.admin.report_statuses": "{name} 举报了 {target}，原因为 {category}",
  "notification.admin.report_statuses_other": "{name} 举报了 {target}",
  "notification.admin.sign_up": "{name} 注册了",
  "notification.admin.sign_up.name_and_others": "{name} 和 {count, plural, other {另外 # 人}}注册了",
  "notification.annual_report.message": "你的 {year} #Wrapstodon 年度回顾来啦！快来看看这一年你在 Mastodon 上的精彩瞬间！",
  "notification.annual_report.view": "查看 #Wrapstodon 年度回顾",
  "notification.collection_update": "{name} 编辑了你所在的收藏列表",
  "notification.favourite": "{name} 喜欢了你的嘟文",
  "notification.favourite.name_and_others_with_link": "{name} 和 <a>{count, plural, other {另外 # 人}}</a> 喜欢了你的嘟文",
  "notification.favourite_pm": "{name} 喜欢了你的私下提及",
  "notification.favourite_pm.name_and_others_with_link": "{name} 和<a>{count, plural, other {另外 # 人}}</a>喜欢了你的私下提及",
  "notification.follow": "{name} 关注了你",
  "notification.follow.name_and_others": "{name} 和 <a>{count, plural, other {另外 # 人}}</a> 关注了你",
  "notification.follow_request": "{name} 向你发送了关注请求",
  "notification.follow_request.name_and_others": "{name} 和 {count, plural, other {另外 # 人}} 向你发送了关注请求",
  "notification.label.mention": "提及",
  "notification.label.private_mention": "私下提及",
  "notification.label.private_reply": "私人回复",
  "notification.label.quote": "{name} 引用了你的嘟文",
  "notification.label.reply": "回复",
  "notification.mention": "提及",
  "notification.mentioned_you": "{name} 提到了你",
  "notification.moderation-warning.learn_more": "详细了解",
  "notification.moderation_warning": "你收到了一条管理警告",
  "notification.moderation_warning.action_delete_statuses": "你的一些嘟文已被移除。",
  "notification.moderation_warning.action_disable": "你的账号已被禁用。",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "你的一些嘟文已被标记为敏感内容。",
  "notification.moderation_warning.action_none": "你的账号收到了管理警告。",
  "notification.moderation_warning.action_sensitive": "今后你的嘟文都会被标记为敏感内容。",
  "notification.moderation_warning.action_silence": "你的账号已被隐藏。",
  "notification.moderation_warning.action_suspend": "你的账号已被封禁。",
  "notification.own_poll": "你的投票已经结束",
  "notification.poll": "你参与的一项投票已结束",
  "notification.quoted_update": "{name} 编辑了一条你之前引用过的嘟文",
  "notification.reblog": "{name} 转发了你的嘟文",
  "notification.reblog.name_and_others_with_link": "{name} 和 <a>{count, plural, other {另外 # 人}}</a> 转嘟了你的嘟文",
  "notification.relationships_severance_event": "与 {name} 的联系已断开",
  "notification.relationships_severance_event.account_suspension": "{from} 的管理员封禁了 {target}，这意味着你将无法再收到对方的更新或与其互动。",
  "notification.relationships_severance_event.domain_block": "{from} 的管理员屏蔽了 {target}，其中包括你的 {followersCount} 个关注者和 {followingCount, plural, other {# 个关注}}。",
  "notification.relationships_severance_event.learn_more": "详细了解",
  "notification.relationships_severance_event.user_domain_block": "你已经屏蔽了 {target}，移除了你的 {followersCount} 个关注者和 {followingCount, plural, other {# 个关注}}。",
  "notification.status": "{name} 刚刚发布嘟文",
  "notification.update": "{name} 编辑了嘟文",
  "notification_requests.accept": "接受",
  "notification_requests.accept_multiple": "{count, plural, other {接受 # 个请求…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, other {接受请求}}",
  "notification_requests.confirm_accept_multiple.message": "你即将接受 {count, plural, other {# 个通知请求}}。是否确定要继续？",
  "notification_requests.confirm_accept_multiple.title": "是否接受通知请求？",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, other {拒绝请求}}",
  "notification_requests.confirm_dismiss_multiple.message": "你将要拒绝 {count, plural, other {# 个通知请求}}。你将无法再轻易访问{count, plural, other {它们}}。是否继续？",
  "notification_requests.confirm_dismiss_multiple.title": "是否拒绝通知请求?",
  "notification_requests.dismiss": "忽略",
  "notification_requests.dismiss_multiple": "{count, plural, other {拒绝 # 个请求…}}",
  "notification_requests.edit_selection": "编辑",
  "notification_requests.exit_selection": "完成",
  "notification_requests.explainer_for_limited_account": "来自该账号的通知已被过滤，因为该账号已被管理员限制。",
  "notification_requests.explainer_for_limited_remote_account": "来自该账号的通知已被过滤，因为该账号或其所在的实例已被管理员限制。",
  "notification_requests.maximize": "最大化",
  "notification_requests.minimize_banner": "最小化被过滤通知横幅",
  "notification_requests.notifications_from": "来自 {name} 的通知",
  "notification_requests.title": "被过滤的通知",
  "notification_requests.view": "查看通知",
  "notifications.clear": "清空通知列表",
  "notifications.clear_confirmation": "确定要永久清空通知列表吗？",
  "notifications.clear_title": "确定要清空通知？",
  "notifications.column_settings.admin.report": "新举报：",
  "notifications.column_settings.admin.sign_up": "新注册：",
  "notifications.column_settings.alert": "桌面通知",
  "notifications.column_settings.collections": "收藏列表：",
  "notifications.column_settings.favourite": "喜欢：",
  "notifications.column_settings.filter_bar.advanced": "显示全部类别",
  "notifications.column_settings.filter_bar.category": "快速筛选栏",
  "notifications.column_settings.follow": "新关注者：",
  "notifications.column_settings.follow_request": "新关注请求：",
  "notifications.column_settings.group": "分组",
  "notifications.column_settings.mention": "提及：",
  "notifications.column_settings.poll": "投票结果：",
  "notifications.column_settings.push": "推送通知",
  "notifications.column_settings.quote": "引用嘟文：",
  "notifications.column_settings.reblog": "转嘟：",
  "notifications.column_settings.show": "在通知栏显示",
  "notifications.column_settings.sound": "播放音效",
  "notifications.column_settings.status": "新嘟文：",
  "notifications.column_settings.unread_notifications.category": "未读通知",
  "notifications.column_settings.unread_notifications.highlight": "高亮显示未读通知",
  "notifications.column_settings.update": "编辑：",
  "notifications.filter.all": "全部",
  "notifications.filter.boosts": "转嘟",
  "notifications.filter.collections": "收藏列表",
  "notifications.filter.favourites": "喜欢",
  "notifications.filter.follows": "关注",
  "notifications.filter.mentions": "提及",
  "notifications.filter.polls": "投票结果",
  "notifications.filter.statuses": "你关注的人的动态",
  "notifications.grant_permission": "授予权限",
  "notifications.group": "{count} 条通知",
  "notifications.mark_as_read": "将所有通知标为已读",
  "notifications.permission_denied": "由于权限被拒绝，无法启用桌面通知。",
  "notifications.permission_denied_alert": "由于在此之前浏览器权限请求就已被拒绝，所以启用桌面通知失败",
  "notifications.permission_required": "所需权限未被授予，所以桌面通知不可用",
  "notifications.policy.accept": "接受",
  "notifications.policy.accept_hint": "在通知中显示",
  "notifications.policy.drop": "忽略",
  "notifications.policy.drop_hint": "送入虚空，再也不查看",
  "notifications.policy.filter": "过滤",
  "notifications.policy.filter_bots_hint": "被标记为自动化的账号",
  "notifications.policy.filter_bots_title": "机器人",
  "notifications.policy.filter_hint": "发送到被过滤通知列表",
  "notifications.policy.filter_limited_accounts_hint": "被服务器管理员限制的账号",
  "notifications.policy.filter_limited_accounts_title": "受限账号",
  "notifications.policy.filter_new_accounts.hint": "注册未满 {days, plural, other {# 天}} 的账号",
  "notifications.policy.filter_new_accounts_title": "新账号",
  "notifications.policy.filter_not_followers_hint": "包括关注你未满 {days, plural, other {# 天}}的人",
  "notifications.policy.filter_not_followers_title": "没有关注你的人",
  "notifications.policy.filter_not_following_hint": "需要你手动批准",
  "notifications.policy.filter_not_following_title": "需要你手动批准",
  "notifications.policy.filter_private_mentions_hint": "过滤通知，除非对应嘟文是在回复你的私下提及，或来自你关注的人。",
  "notifications.policy.filter_private_mentions_title": "不请自来的私下提及",
  "notifications.policy.title": "管理来自 … 的通知",
  "notifications_permission_banner.enable": "启用桌面通知",
  "notifications_permission_banner.how_to_control": "启用桌面通知以在 Mastodon 未打开时接收通知。你可以通过交互通过上面的 {icon} 按钮来精细控制可以发送桌面通知的交互类型。",
  "notifications_permission_banner.title": "精彩不容错过",
  "onboarding.follows.back": "返回",
  "onboarding.follows.empty": "很抱歉，现在无法显示任何结果。你可以尝试使用搜索或浏览探索页面来查找要关注的人，或稍后再试。",
  "onboarding.follows.next": "下一步：设置你的个人资料",
  "onboarding.follows.search": "搜索",
  "onboarding.follows.title": "关注用户，玩转 Mastodon",
  "onboarding.profile.discoverable": "让我的账号可被他人发现",
  "onboarding.profile.discoverable_hint": "当你在 Mastodon 上启用发现功能时，你的嘟文可能会出现在搜索结果与热门中，你的账号可能会被推荐给与你兴趣相似的人。",
  "onboarding.profile.display_name": "昵称",
  "onboarding.profile.display_name_hint": "你的全名或昵称…",
  "onboarding.profile.finish": "完成",
  "onboarding.profile.note": "简介",
  "onboarding.profile.note_hint": "你可以提及 @其他人 或使用 #话题…",
  "onboarding.profile.title": "设置个人资料",
  "onboarding.profile.upload_avatar": "上传头像",
  "onboarding.profile.upload_header": "上传账号封面图",
  "password_confirmation.exceeds_maxlength": "密码确认超过最大密码长度",
  "password_confirmation.mismatching": "确认密码与密码不一致。",
  "picture_in_picture.restore": "恢复",
  "poll.closed": "已关闭",
  "poll.refresh": "刷新",
  "poll.reveal": "查看结果",
  "poll.total_people": "{count} 人",
  "poll.total_votes": "{count} 票",
  "poll.vote": "投票",
  "poll.voted": "你已经对这个答案投过票了",
  "poll.votes": "{votes, plural, one {# 票} other {# 票}}",
  "poll_button.add_poll": "发起投票",
  "poll_button.remove_poll": "移除投票",
  "privacy.change": "设置嘟文的可见范围",
  "privacy.direct.long": "嘟文中提到的每个人",
  "privacy.direct.short": "私下提及",
  "privacy.private.long": "仅限你的关注者",
  "privacy.private.short": "关注者",
  "privacy.public.long": "所有 Mastodon 内外的人",
  "privacy.public.short": "公开",
  "privacy.quote.anyone": "{visibility}，允许嘟文引用",
  "privacy.quote.disabled": "{visibility}，禁用嘟文引用",
  "privacy.quote.limited": "{visibility}，嘟文引用受限",
  "privacy.unlisted.additional": "此模式的行为与“公开”类似，只是嘟文不会出现在实时动态、话题、探索或 Mastodon 搜索页面中，即使你已全局开启了对应的发现设置。",
  "privacy.unlisted.long": "不显示在Mastodon的搜索结果、热门趋势、公共时间线上",
  "privacy.unlisted.short": "悄悄公开",
  "privacy_policy.last_updated": "最近更新于 {date}",
  "privacy_policy.title": "隐私政策",
  "quote_error.edit": "编辑嘟文时无法添加引用。",
  "quote_error.poll": "不允许引用投票嘟文。",
  "quote_error.private_mentions": "不允许引用私下提及嘟文。",
  "quote_error.quote": "一次只能引用一条嘟文。",
  "quote_error.unauthorized": "你没有权限引用此嘟文。",
  "quote_error.upload": "不允许引用有媒体附件的嘟文。",
  "recommended": "推荐",
  "refresh": "刷新",
  "regeneration_indicator.please_stand_by": "请稍候。",
  "regeneration_indicator.preparing_your_home_feed": "正在为你准备主页时间线...",
  "relative_time.days": "{number} 天前",
  "relative_time.full.days": "{number, plural, other {# 天}}前",
  "relative_time.full.hours": "{number, plural, other {# 小时}}前",
  "relative_time.full.just_now": "刚刚",
  "relative_time.full.minutes": "{number, plural, other {# 分钟}}前",
  "relative_time.full.seconds": "{number, plural, other {# 秒}}前",
  "relative_time.hours": "{number} 小时前",
  "relative_time.just_now": "刚刚",
  "relative_time.minutes": "{number} 分钟前",
  "relative_time.seconds": "{number} 秒前",
  "relative_time.today": "今天",
  "remove_quote_hint.button_label": "明白了",
  "remove_quote_hint.message": "你可以通过 {icon} 选项菜单进行此操作。",
  "remove_quote_hint.title": "是否想要移除你的引用嘟文？",
  "reply_indicator.attachments": "{count, plural, other {# 个附件}}",
  "reply_indicator.cancel": "取消",
  "reply_indicator.poll": "投票",
  "report.block": "屏蔽",
  "report.block_explanation": "你将无法看到他们的嘟文。他们也将无法看到你的嘟文或关注你。他们将能够判断出他们被屏蔽了。",
  "report.categories.legal": "法律义务",
  "report.categories.other": "其他",
  "report.categories.spam": "垃圾信息",
  "report.categories.violation": "内容违反一条或多条服务器规则",
  "report.category.subtitle": "选择最佳匹配",
  "report.close": "完成",
  "report.comment.title": "还有什么你认为我们应该知道的吗？",
  "report.forward": "转发举报至 {target}",
  "report.forward_hint": "这名用户来自另一个服务器。是否要向那个服务器发送一条匿名的举报？",
  "report.mute": "隐藏",
  "report.mute_explanation": "你将不会看到他们的嘟文。他们仍然可以关注你并看到你的嘟文，但他们不会知道你忽略了来自他们的信息。",
  "report.next": "下一步",
  "report.placeholder": "备注",
  "report.reasons.dislike": "令人反感",
  "report.reasons.dislike_description": "这不是你想看到的东西",
  "report.reasons.legal": "非法信息",
  "report.reasons.legal_description": "你认为它违反了你或你的实例所在国家的法律",
  "report.reasons.other": "其他原因",
  "report.reasons.other_description": "该问题不符合其他类别",
  "report.reasons.spam": "垃圾信息",
  "report.reasons.spam_description": "恶意链接、虚假互动或重复回复",
  "report.reasons.violation": "违反服务器规则",
  "report.reasons.violation_description": "你清楚它违反了特定的规则",
  "report.rules.subtitle": "选择全部适用选项",
  "report.rules.title": "违反了哪些规则？",
  "report.statuses.subtitle": "选择全部适用选项",
  "report.statuses.title": "是否有任何嘟文可以支持这一报告？",
  "report.submission_error": "无法提交举报",
  "report.submission_error_details": "请检查网络连接，然后再试一次。",
  "report.submit": "提交",
  "report.target": "举报 {target}",
  "report.thanks.take_action": "以下是你控制你在 Mastodon 上能看到哪些内容的选项：",
  "report.thanks.take_action_actionable": "在我们审阅这个问题时，你可以对 @{name} 采取行动",
  "report.thanks.title": "不想看到这个内容？",
  "report.thanks.title_actionable": "感谢提交举报，我们将会进行处理。",
  "report.unfollow": "取消关注 @{name}",
  "report.unfollow_explanation": "你正在关注此账号。如果不想继续在主页看到他们的嘟文，取消对他们的关注即可。",
  "report_notification.attached_statuses": "附上 {count} 条嘟文",
  "report_notification.categories.legal": "法律义务",
  "report_notification.categories.legal_sentence": "非法内容",
  "report_notification.categories.other": "其他",
  "report_notification.categories.other_sentence": "其他",
  "report_notification.categories.spam": "骚扰",
  "report_notification.categories.spam_sentence": "骚扰",
  "report_notification.categories.violation": "违反规则",
  "report_notification.categories.violation_sentence": "违反规则",
  "report_notification.open": "打开举报",
  "search.clear": "清空搜索内容",
  "search.no_recent_searches": "无最近搜索",
  "search.placeholder": "搜索",
  "search.quick_action.account_search": "包含 {x} 的账号",
  "search.quick_action.go_to_account": "打开 {x} 的个人资料",
  "search.quick_action.go_to_hashtag": "打开话题 {x}",
  "search.quick_action.open_url": "在 Mastodon 中打开此链接",
  "search.quick_action.status_search": "包含 {x} 的嘟文",
  "search.search_or_paste": "搜索或输入网址",
  "search_popout.full_text_search_disabled_message": "在 {domain} 不可用",
  "search_popout.full_text_search_logged_out_message": "只有登录后才可用。",
  "search_popout.language_code": "ISO语言代码",
  "search_popout.options": "搜索选项",
  "search_popout.quick_actions": "快捷操作",
  "search_popout.recent": "最近搜索",
  "search_popout.specific_date": "具体日期",
  "search_popout.user": "用户",
  "search_results.accounts": "用户",
  "search_results.all": "全部",
  "search_results.collections": "收藏列表",
  "search_results.hashtags": "话题",
  "search_results.no_results": "未找到结果。",
  "search_results.no_search_yet": "不妨试下搜索嘟文、账号或话题。",
  "search_results.see_all": "查看全部",
  "search_results.statuses": "嘟文",
  "search_results.title": "搜索 “{q}”",
  "server_banner.about_active_users": "过去 30 天内使用此服务器的人(月活跃用户)",
  "server_banner.active_users": "活跃用户",
  "server_banner.administered_by": "本站管理员：",
  "server_banner.is_one_of_many": "{domain} 是可用于参与联邦宇宙的众多独立 Mastodon 站点之一。",
  "server_banner.more_about_this_server": "关于此服务器的更多信息",
  "server_banner.server_stats": "服务器统计数据：",
  "sign_in_banner.create_account": "创建账号",
  "sign_in_banner.follow_anyone": "关注联邦宇宙中的任何人，并按时间顺序查看全部内容。没有算法、广告或诱导链接。",
  "sign_in_banner.mastodon_is": "Mastodon 是了解最新动态的最佳途径。",
  "sign_in_banner.sign_in": "登录",
  "sign_in_banner.sso_redirect": "登录或注册",
  "skip_links.hotkey": "<span>快捷键</span> {hotkey}",
  "skip_links.skip_to_content": "跳转到主内容",
  "skip_links.skip_to_navigation": "跳转到主导航",
  "status.admin_account": "打开 @{name} 的管理界面",
  "status.admin_domain": "打开 {domain} 的管理界面",
  "status.admin_status": "在管理界面查看此嘟文",
  "status.all_disabled": "已禁用转嘟与引用",
  "status.block": "屏蔽 @{name}",
  "status.bookmark": "添加到书签",
  "status.cancel_reblog_private": "取消转嘟",
  "status.cannot_quote": "你无权引用这条嘟文",
  "status.cannot_reblog": "不能转嘟这条嘟文",
  "status.contains_quote": "包含引用",
  "status.context.loading": "正在加载更多回复",
  "status.context.loading_error": "无法加载新回复",
  "status.context.loading_success": "已加载新回复",
  "status.context.more_replies_found": "已找到更多回复",
  "status.context.retry": "重试",
  "status.context.show": "显示",
  "status.continued_thread": "上接嘟文串",
  "status.copy": "复制嘟文链接",
  "status.delete": "删除",
  "status.delete.success": "嘟文已删除",
  "status.detailed_status": "对话详情",
  "status.direct": "私下提及 @{name}",
  "status.direct_indicator": "私下提及",
  "status.edit": "编辑",
  "status.edited": "最后编辑于 {date}",
  "status.edited_x_times": "共编辑 {count, plural, other {{count} 次}}",
  "status.embed": "获取嵌入代码",
  "status.favourite": "喜欢",
  "status.favourites_count": "{count, plural, other {{counter} 次喜欢}}",
  "status.filter": "过滤此嘟文",
  "status.history.created": "{name} 创建于 {date}",
  "status.history.edited": "{name} 编辑于 {date}",
  "status.load_more": "加载更多",
  "status.media.open": "点击打开",
  "status.media.show": "点击查看",
  "status.media_hidden": "媒体已隐藏",
  "status.mention": "提及 @{name}",
  "status.more": "更多",
  "status.mute": "隐藏 @{name}",
  "status.mute_conversation": "关闭此对话的通知",
  "status.open": "展开嘟文",
  "status.pin": "在个人资料页面置顶",
  "status.quote": "引用",
  "status.quote.cancel": "取消引用",
  "status.quote_error.blocked_account_hint.title": "由于你已屏蔽@{name}，此嘟文已隐藏。",
  "status.quote_error.blocked_domain_hint.title": "由于你已屏蔽{domain}，此嘟文已隐藏。",
  "status.quote_error.filtered": "已根据你的筛选器过滤",
  "status.quote_error.limited_account_hint.action": "仍然显示",
  "status.quote_error.limited_account_hint.title": "此账号已被 {domain} 管理员隐藏。",
  "status.quote_error.muted_account_hint.title": "由于你已设置隐藏@{name}，此嘟文已隐藏。",
  "status.quote_error.not_available": "嘟文不可用",
  "status.quote_error.pending_approval": "嘟文待发布",
  "status.quote_error.pending_approval_popout.body": "在Mastodon上，你可以控制其他人引用你嘟文的权限。此嘟文在得到原作者的同意后就会发布。",
  "status.quote_error.revoked": "嘟文已被作者删除",
  "status.quote_followers_only": "只有关注者才能引用这篇嘟文",
  "status.quote_manual_review": "嘟文作者将人工审核",
  "status.quote_noun": "引用",
  "status.quote_policy_change": "更改谁可以引用",
  "status.quote_post_author": "引用了 @{name} 的嘟文",
  "status.quote_private": "不能引用私人嘟文",
  "status.quotes.empty": "还没有人引用过此条嘟文。引用此嘟文的人会显示在这里。",
  "status.quotes.local_other_disclaimer": "遭作者拒绝的引用将不会显示。",
  "status.quotes.remote_other_disclaimer": "此处仅保证会显示来自 {domain} 的引用。遭作者拒绝的引用将不会显示。",
  "status.quotes_count": "{count, plural, other {{counter} 次引用}}",
  "status.read_more": "查看更多",
  "status.reblog": "转嘟",
  "status.reblog_or_quote": "转嘟或引用",
  "status.reblog_private": "向关注者再次分享",
  "status.reblogged_by": "{name} 转嘟了",
  "status.reblogs.empty": "没有人转嘟过此条嘟文。如果有人转嘟了，就会显示在这里。",
  "status.reblogs_count": "{count, plural, other {{counter} 次转嘟}}",
  "status.redraft": "删除并重新编辑",
  "status.remove_bookmark": "移除书签",
  "status.remove_favourite": "从喜欢列表中移除",
  "status.remove_quote": "移除",
  "status.replied_in_thread": "回复嘟文串",
  "status.replied_to": "回复 {name}",
  "status.reply": "回复",
  "status.replyAll": "回复此嘟文串",
  "status.report": "举报 @{name}",
  "status.request_quote": "请求引用",
  "status.revoke_quote": "将我的嘟文从 @{name} 的嘟文中删除",
  "status.sensitive_warning": "敏感内容",
  "status.share": "分享",
  "status.show_less_all": "全部折叠",
  "status.show_more_all": "全部展开",
  "status.show_original": "显示原文",
  "status.title.with_attachments": "{user} 上传了 {attachmentCount, plural, other {{attachmentCount} 个附件}}",
  "status.translate": "翻译",
  "status.translated_from_with": "由 {provider} 翻译自 {lang}",
  "status.uncached_media_warning": "预览不可用",
  "status.unmute_conversation": "恢复此对话的通知提醒",
  "status.unpin": "在个人资料页面取消置顶",
  "subscribed_languages.lead": "更改此选择后，只有选定语言的嘟文才会出现在你的主页和列表时间线上。选择「无」将显示全部语言的嘟文。",
  "subscribed_languages.save": "保存更改",
  "subscribed_languages.target": "更改 {target} 的订阅语言",
  "tabs_bar.home": "主页",
  "tabs_bar.menu": "菜单",
  "tabs_bar.notifications": "通知",
  "tabs_bar.publish": "新嘟文",
  "tabs_bar.quick_links": "快捷链接",
  "tabs_bar.search": "搜索",
  "tag.remove": "移除",
  "terms_of_service.effective_as_of": "自 {date} 起生效",
  "terms_of_service.title": "服务条款",
  "terms_of_service.upcoming_changes_on": "{date} 起即将生效的更改",
  "time_remaining.days": "剩余 {number, plural, other {# 天}}",
  "time_remaining.hours": "剩余 {number, plural, other {# 小时}}",
  "time_remaining.minutes": "剩余 {number, plural, other {# 分钟}}",
  "time_remaining.moments": "即将结束",
  "time_remaining.seconds": "剩余 {number, plural, other {# 秒}}",
  "trends.counter_by_accounts": "过去 {days, plural, other {{days} 天}}有{count, plural, other { {counter} 人}}讨论",
  "trends.trending_now": "当前热门",
  "ui.beforeunload": "如果你现在离开 Mastodon，你的草稿内容将会丢失。",
  "units.short.billion": "{count} B",
  "units.short.million": "{count} M",
  "units.short.thousand": "{count} K",
  "upload_area.title": "将文件拖放到此处开始上传",
  "upload_button.label": "上传图片、视频或音频",
  "upload_error.limit": "文件大小超过限制。",
  "upload_error.poll": "投票中不允许上传文件。",
  "upload_error.quote": "引用中不允许上传文件。",
  "upload_form.drag_and_drop.instructions": "要选中某个媒体附件，请按空格键或回车键。在拖拽时，使用方向键将媒体附件移动到任何给定方向。再次按空格键或回车键可将媒体附件放置在新位置，或按 Esc 键取消。",
  "upload_form.drag_and_drop.on_drag_cancel": "拖拽已终止。媒体附件 {item} 已被丢弃。",
  "upload_form.drag_and_drop.on_drag_end": "媒体附件 {item} 已被丢弃。",
  "upload_form.drag_and_drop.on_drag_over": "媒体附件 {item} 已被移动。",
  "upload_form.drag_and_drop.on_drag_start": "已选中媒体附件 {item}。",
  "upload_form.edit": "编辑",
  "upload_progress.label": "上传中…",
  "upload_progress.processing": "正在处理…",
  "username.taken": "此用户名已被占用。请换用其他用户名",
  "video.close": "关闭视频",
  "video.download": "下载文件",
  "video.exit_fullscreen": "退出全屏",
  "video.expand": "展开视频",
  "video.fullscreen": "全屏",
  "video.hide": "隐藏视频",
  "video.mute": "停止提醒",
  "video.pause": "暂停",
  "video.play": "播放",
  "video.skip_backward": "后退",
  "video.skip_forward": "前进",
  "video.unmute": "恢复提醒",
  "video.volume_down": "音量减小",
  "video.volume_up": "提高音量",
  "visibility_modal.button_title": "设置可见性",
  "visibility_modal.direct_quote_warning.text": "如果你保存当前设置，引用的嘟文将被转换为链接。",
  "visibility_modal.direct_quote_warning.title": "引用嘟文无法嵌入到私下提及中",
  "visibility_modal.header": "可见性和互动",
  "visibility_modal.helper.direct_quoting": "Mastodon上发布的私下提及无法被他人引用。",
  "visibility_modal.helper.privacy_editing": "嘟文发布后便无法更改可见性。",
  "visibility_modal.helper.privacy_private_self_quote": "自我引用的私人嘟文无法设置为公开。",
  "visibility_modal.helper.private_quoting": "Mastodon上发布的仅限关注者可见的嘟文无法被他人引用。",
  "visibility_modal.helper.unlisted_quoting": "当其他人引用你时，他们的嘟文也会从热门时间线上隐藏。",
  "visibility_modal.instructions": "控制谁可以和此嘟文互动。你也可以前往<link>偏好设置 > 发布默认值</link>将此设置应用到全部未来发布的嘟文。",
  "visibility_modal.privacy_label": "可见性",
  "visibility_modal.quote_followers": "仅关注者",
  "visibility_modal.quote_label": "谁可以引用",
  "visibility_modal.quote_nobody": "仅限自己",
  "visibility_modal.quote_public": "任何人",
  "visibility_modal.save": "保存"
}
